import { render, staticRenderFns } from "./Shortlink.vue?vue&type=template&id=b4bf36ce&scoped=true&"
import script from "./Shortlink.vue?vue&type=script&lang=js&"
export * from "./Shortlink.vue?vue&type=script&lang=js&"
import style0 from "./Shortlink.vue?vue&type=style&index=0&id=b4bf36ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf36ce",
  null
  
)

export default component.exports